import { Props as BaseButtonProps, BaseButton } from './BaseButton';

export type Props = Omit<BaseButtonProps, 'isPill'> & {
  color?:
    | 'brand'
    | 'danger'
    | 'ghost'
    | 'primary'
    | 'primary-alt'
    | 'primary-dark'
    | 'secondary'
    | 'secondary-dark'
    | 'tertiary';
};

/**
 * Classic button component. Use when providing calls to action to users.
 *
 * @deprecated Use `Button` instead. `LegacyButton` will be removed in a future release.
 */
export function LegacyButton({
  color = 'primary',
  size = 'medium',
  ...props
}: Props) {
  return <BaseButton color={color} size={size} {...props} />;
}
